var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"tw-h-auto tw-shrink-0 tw-cursor-pointer",style:({ width: _vm.widthCss }),attrs:{"alt":_vm.alt,"src":_vm.src}})
}
var staticRenderFns = []

export { render, staticRenderFns }